export default "__VITE_ASSET__BmKgohjj__"